import React from 'react';
import { createRoot } from 'react-dom/client';
import { DevicePrint } from '@ally/transmitigator';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { StateProvider } from './store/store';
import { BroadcastDispatchProvider, TransmitProvider } from './contexts';
import { HelmetProvider } from 'react-helmet-async';

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <DevicePrint />
      <StateProvider>
        <BroadcastDispatchProvider>
          <TransmitProvider>
            <App />
          </TransmitProvider>
        </BroadcastDispatchProvider>
      </StateProvider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
